export class Coupon {
    Id: number;
    CouponName: string;
    CouponDescription: string;
    Sum: number;
    Type: number;
    MaxCouponCodes: number;
    CouponCodeUses: number;
    Endtime: Date;
    Updated: string;
    Created: string;
    Active: boolean;
  }
  
  export class CouponCode {
    Id: number;
    CouponId: number;
    UserEmail: string;
    CouponCodeUid: string;
    Updated: string;
    Created: string;
    Active: boolean;
  }
  export class CouponView {
    Coupon: Coupon;
    CouponCode: CouponCode;
  }